<template>
  <tg-layout>
    <template slot="header">
      <tg-search-tool @on-submit="handleSearch" :disabled="!searchName">
        <tg-dropdown
          :autoWidth="false"
          :items="filters"
          @on-change="handleFilterChange"
          trigger="click"
        >
          <template slot="icon">
            <i class="tg-icon tg-icon-notlogin"></i>
          </template>
        </tg-dropdown>
        <el-input
          :placeholder="$t('component.form.input.placeholder.member')"
          v-model="searchName"
          class="tg-input input-search-username"
          size="small"
          clearable
        ></el-input>
        <template slot="after">
          <!-- 批量操作 -->
          <tg-button
            v-if="showBulkActionBtn"
            theme="blue-green"
            round
            activeGradient
            @click.native="handleShowBulkDialog"
          >
            {{ $t("component.btn.bulk_operation") }}
          </tg-button>
        </template>
      </tg-search-tool>

      <template v-if="showTopTable">
        <tg-table
          ref="topTable"
          :columns="columns"
          :proxy="findProxy"
          align="center"
          :fit="true"
          :tableHeight="145"
          class="page--top-table"
          @on-loaded="handleLoaded"
          :header-cell-class-name="addLockColumns"
        >
          <template slot="userfullname" slot-scope="scope">
            {{ scope.row["username"] }} ({{ scope.row["usernickname"] }})
          </template>

          <template slot="statusBtn" slot-scope="scope">
            
            <tg-status-btn
              :status="scope.value"
              :disabled="!scope.column.enable_change || isSub"
              @on-click="
                handlePrivilegeStatusChange(
                  'topTable',
                  scope.column,
                  scope.value,
                  scope.row
                )
              "
              @on-click-disabled="
                handlePrivilegeStatusChange(
                  'topTable',
                  scope.column,
                  scope.value,
                  scope.row,
                  true
                )
              "
            ></tg-status-btn>
          </template>
          <template slot="statusBtnWithLock" slot-scope="scope">
            <el-row type="flex" justify="center" align="middle">
              <tg-status-btn
              :status="scope.value"
              :disabled="!scope.column.enable_change || isSub"
              @on-click="
                handlePrivilegeStatusChange(
                  'topTable',
                  scope.column,
                  scope.value,
                  scope.row
                )
              "
              @on-click-disabled="
                handlePrivilegeStatusChange(
                  'topTable',
                  scope.column,
                  scope.value,
                  scope.row,
                  true
                )
              "
            ></tg-status-btn>
            <tg-button
            v-if="scope.row[scope.column.lockKey] != null"
              round
              border
              theme="danger"
              @click.native="handleUnclockClick(scope.column, scope.row, 'topTable')"
            >
              {{ $t("component.btn.locked")}}
              <font-awesome-icon icon="times" size="1x"></font-awesome-icon>
            </tg-button>
            </el-row>
          </template>
          <template slot="loginTip" slot-scope="scope">
            <template v-if="scope.value">
              {{ $t("component.label.loginTip", { value: scope.value }) }}
            </template>
          </template>
        </tg-table>
        <el-row v-if="maxLevel > 0">
          <template v-for="num in maxLevel">
            <tg-button
              round
              border
              hoverBorderOnly
              theme="primary"
              :active-gradient="num == selectedLevel"
              :key="num"
              @click.native="handleLevelClick(num)"
              >{{ $t("enum.level[" + (num - 1) + "]") }}</tg-button
            >
          </template>
        </el-row>
      </template>
    </template>

    <template v-if="showTopTable && showTable">
      <tg-table
        ref="table"
        :columns="columns"
        :proxy="proxy"
        align="center"
        :fit="true"
        showPagination
        :header-cell-class-name="addLockColumns"
        @on-loaded="handleLevelDataLoaded"
      >
        <template slot="userfullname" slot-scope="scope">
          <tg-user-full-name
            :row="scope.row"
            :column="{
              name: 'username',
              nickname: 'usernickname',
              langKey: 'l10_account',
              title: '会员帐号',
            }"
          ></tg-user-full-name>
        </template>

        <template slot="statusBtn" slot-scope="scope">
          <tg-status-btn
            :status="scope.value"
            :disabled="!scope.column.enable_change || isSub"
            @on-click="
              handlePrivilegeStatusChange(
                'table',
                scope.column,
                scope.value,
                scope.row
              )
            "
            @on-click-disabled="
              handlePrivilegeStatusChange(
                'table',
                scope.column,
                scope.value,
                scope.row,
                true
              )
            "
          ></tg-status-btn>
        </template>

        <template slot="statusBtnWithLock" slot-scope="scope">
            <el-row type="flex" justify="center" align="middle">
              <tg-status-btn
              :status="scope.value"
              :disabled="!scope.column.enable_change || isSub"
              @on-click="
                handlePrivilegeStatusChange(
                  'table',
                  scope.column,
                  scope.value,
                  scope.row
                )
              "
              @on-click-disabled="
                handlePrivilegeStatusChange(
                  'table',
                  scope.column,
                  scope.value,
                  scope.row,
                  true
                )
              "
            ></tg-status-btn>
            <tg-button
              v-if="scope.row[scope.column.lockKey] != null"
              round
              border
              theme="danger"
              @click.native="handleUnclockClick(scope.column, scope.row, 'table')"
            >
              {{ $t("component.btn.locked")}}
              <font-awesome-icon icon="times" size="1x"></font-awesome-icon>
            </tg-button>
            </el-row>
          </template>

        <template slot="loginTip" slot-scope="scope">
          <template v-if="scope.value">
            {{ $t("component.label.loginTip", { value: scope.value }) }}
          </template>
        </template>
      </tg-table>
    </template>
    <template v-if="!showTopTable">
      <div class="tg-bg-white">
        <tg-nodata :isNeedSearch="!isSearch"></tg-nodata>
      </div>
    </template>
    <tg-privilege-change-dialog
      :visible.sync="showPrivilegeChangeDialog"
      v-bind="privilegeChgDialog"
      role="member"
      @on-changed="handlePrivilegeChanged"
    ></tg-privilege-change-dialog>
    <tg-member-privilege-bulk-dialog
      ref="bulkDialog"
      :columns="columns"
      :maxLevel="maxLevel"
      :selectedLevel="selectedLevel"
      :target="target"
      :filters="filters"
      :selectedFilter="computedFilter"
      @bulk-open="handleBulk('open', $event)"
      @bulk-close="handleBulk('close', $event)"
    ></tg-member-privilege-bulk-dialog>
    <tg-privilege-bulk-change-dialog
      :visible.sync="showPrivilegeBulkChangeDialog"
      v-bind="privilegeBulkChgDialog"
      role="member"
      @on-changed="handlePrivilegeBulkChanged"
    ></tg-privilege-bulk-change-dialog>
  </tg-layout>
</template>

<script>
import TgLayout from "@/layout/TgLayout";
import TgSearchTool from "@/components/tool/TgSearchTool";
import TgDropdown from "@/components/dropdown/TgDropdown";
import TgStatusBtn from "@/components/button/TgStatusBtn";
import TgNodata from "@/components/TgNodata";
import TgButton from "@/components/button/TgButton";
import TgPrivilegeChangeDialog from "@/components/dialog/TgPrivilegeChangeDialog";
import TgMemberPrivilegeBulkDialog from "@/components/dialog/TgMemberPrivilegeBulkDialog";
import TgPrivilegeBulkChangeDialog from "@/components/dialog/TgPrivilegeBulkChangeDialog";
import TgUserFullName from "@/components/slot/TgUserFullName";

import apis from "@/apis";
const api = apis.tg_business.member.privilege;

export default {
  components: {
    TgSearchTool,
    TgLayout,
    TgDropdown,
    TgStatusBtn,
    TgNodata,
    TgButton,
    TgPrivilegeChangeDialog,
    TgMemberPrivilegeBulkDialog,
    TgPrivilegeBulkChangeDialog,
    TgUserFullName,
  },
  data() {
    return {
      filter: null,
      searchFilter: null,
      searchName: "",
      columns: [],
      proxy: api.getData,
      findProxy: api.find,
      isSearch: false,
      maxLevel: 0,
      selectedLevel: 0,
      target: {},
      showPrivilegeChangeDialog: false,
      privilegeChgDialog: {
        item: {},
        username: "",
        ref: null,
      },
      hasLevelData: false,
      showPrivilegeBulkChangeDialog: false,
      privilegeBulkChgDialog: {
        filter: 0,
        functional: [],
        level: 0,
        targetName: "",
        update_target: false,
        status: null,
      },
      showTopTable: false,
      showTable: false,
    };
  },
  created() {
    api.getColumns().then((response) => {
      this.columns = response.data;
    });
  },
  computed: {
    filters() {
      let filters = [];
      for (let i = 0; i < 4; i++) {
        filters.push({
          label: this.$t("enum.date_filter[" + i + "]"),
          value: i,
        });
      }
      filters[0].active = true;
      return filters;
    },
    computedFilter() {
      return !this.searchFilter ? 0 : this.searchFilter.value;
    },
    request() {
      return {
        targetName: this.searchName,
        filter: this.computedFilter,
      };
    },
    levelRequest() {
      return {
        targetName: this.target.username,
        filter: this.computedFilter,
        level: this.selectedLevel,
      };
    },
    showBulkActionBtn() {
      return (
        !this.isSub &&
        this.isSearch &&
        this.selectedLevel > 0 &&
        this.hasLevelData
      );
    },
  },
  methods: {
    handleSearch() {
      this.showTopTable = true;
      this.isSearch = true;
      this.showTable = false;
      this.maxLevel = 0;
      this.searchFilter = this.filter;
      this.selectedLevel = 0;
      this.$nextTick(() => {
        this.$refs.topTable.search(this.request);
      });
    },
    handleFilterChange(item) {
      this.filter = item;
    },
    handleLoaded(response) {
      if(response.retcode == 0){
        let showTopTable = response.data.length > 0;
        this.showTopTable = showTopTable;
        this.maxLevel = response.maxLevel;
        this.target = response.data[0];
        if (showTopTable && response.maxLevel == 0) {
          this.showTable = true;
          this.$nextTick(() => {
            this.$refs.table.initWithoutFetch();
          });
        }
      }
    },
    handleLevelClick(level) {
      this.selectedLevel = level;
      this.showTable = true;
      this.$nextTick(() => {
        this.$refs.table.search(this.levelRequest);
      });
    },
    handleLevelDataLoaded(response) {
      if(response.retcode == 0){
        this.hasLevelData = response.data.length > 0;
      }
    },
    handlePrivilegeStatusChange(ref, column, status, row, noPrivilege) {
      let type = column.privilege_type;
      let privilege = column.privilege_item;

      let dialog = {
        item: {
          status,
          privilege,
          type,
          label: column.parent
            ? column.parent.title + "-" + column.title
            : column.title,
        },
        username: row["username"],
        noPrivilege,
        refTable: ref,
      };

      this.privilegeChgDialog = dialog;

      this.showPrivilegeChangeDialog = true;
    },
    handlePrivilegeChanged() {
      this.$refs[this.privilegeChgDialog.refTable].refresh();
    },
    handleShowBulkDialog() {
      this.$refs.bulkDialog.showDialog();
    },
    handleBulk(status, request) {
      this.privilegeBulkChgDialog = {
        ...request,
        status,
      };
      this.showPrivilegeBulkChangeDialog = true;
    },
    handlePrivilegeBulkChanged(response) {
      if (response.affected_length == 0) {
        this.$message.info(this.$t("message.info.nochange"));
      }
      this.handleSearch();
    },
    addLockColumns({ column }) {
      let col = this.columns.find((x) => x.name === column.columnKey);

      if (!col || col.slot !== "statusBtn") {
        return "";
      }

      return col.enable_change == false ? "locked" : "";
    },
    handleUnclockClick(column, row, refTable) {
      
      this.$confirm(this.$t('column.item') + ': ' + this.$t('column.' + column.name), this.$t('tip.unclock_confirm'), {
          confirmButtonText: this.$t('component.btn.confirm'),
          cancelButtonText: this.$t('component.btn.cancel'),
          type: 'warning',
          center: true,
          confirmButtonClass: 'tg-btn hover-border-only text-danger'
      }).then(() => {
          api.unlock({privilege_item: column.name, username: row.username}).then(response => {
            if (response.retcode == 0) {
              this.$message({
                type: 'success',
                message: this.$t('message.success.update')
              }); 
            } else {
              this.$message({
                type: 'danger',
                message: this.$t('statusCode[200]')
              }); 
            }
            this.$refs[refTable].refresh();
          });
      }); 
    },
  }
};
</script>
